<div id="acom">
    <div class="container-fluid">
        <div class="row">
            <div class="col-12">
                <div class="inner-card">
                    <h4 class="card-title">Principal's Message To Parents</h4>
                    <div class="card-body text-justify">
                        <!-- <p class="text-justify inner-lead">Provide quality education to children with minimum financial burden on the Parent. We provide students with an immersive, collaborative, and inspiring environment where they can develop a broadly informed, highly disciplined intellect that will help them be successful in whatever work they finally choose.</p> -->
                            <!-- <div class="row">
                                <div class="col-12">
                                    <img src="/assets/img/message/1.jpg" alt="Principal" class="img-fluid rounded">
                                </div>
                            </div> -->
                    </div>
                </div>

            </div>
        </div>
    </div>
</div>